import axios from 'axios';
import { createContext, useState, useEffect } from 'react';
import Api from '../../functions/api';

const ContextoUsuario = createContext(undefined);

const ProvedorUsuario = ({ children }) => {
  const [usuario, atribuirUsuario] = useState(JSON.parse(localStorage.getItem('@userCDIEMS')));

  const atualizarPerfil = (user) => {
    let usuario = JSON.parse(localStorage.getItem('@userCDIEMS'));
    const newUser = { ...usuario, ...user };
    localStorage.setItem('@userCDIEMS', JSON.stringify(newUser));
    atribuirUsuario(newUser);
  };

  const atualizarSessao = (token, tokenExpire) => {
    let usuario = JSON.parse(localStorage.getItem('@userCDIEMS'));
    usuario.tokenString = token;
    usuario.tokenExpiresIn = tokenExpire;
    localStorage.setItem('@userCDIEMS', JSON.stringify(usuario));
    atribuirUsuario(usuario);
  };

  const autenticar = (usuario) => {
    localStorage.setItem('@userCDIEMS', JSON.stringify(usuario));
    atribuirUsuario(usuario);
  };

  const renovarToken = () => {
    Api.get('/Authentication/Renew').then((response) => {
      if (response.status === 200) {
        atualizarSessao(response.data.tokenString, response.data.tokenExpiresIn);
      }
    });
  };

  const sair = () => {
    localStorage.removeItem('@userCDIEMS');
    atribuirUsuario(null);
  };

  useEffect(() => {
    const authInterceptor = Api.api.interceptors.response.use(
      (response) => {
        if (response.status === 401 && usuario) {
          sair();
          throw new axios.Cancel('Operation canceled by the usuario.');
        }
        return response;
      },
      async (error) => {
        if (error?.response?.status === 401) {
          sair();
          throw new axios.Cancel('Operation canceled by the usuario.');
        }
        return error.response;
      },
    );
    return () => {
      Api.api.interceptors.response.eject(authInterceptor);
    };
  }, [usuario]);

  useEffect(() => {
    if (usuario) {
      let seconds = Math.round(new Date() / 1000);
      let mili = (usuario.tokenExpiresIn - seconds - 1200) * 1000;
      let x;
      if (mili > 0) {
        x = setTimeout(() => renovarToken(), mili);
      } else if (mili <= 0 && mili > -600000) {
        renovarToken();
      } else sair();

      return () => clearTimeout(x);
    }
  }, [usuario]);

  return (
    <ContextoUsuario.Provider
      value={{
        usuario,
        autenticar,
        sair,
        atualizarPerfil,
      }}
    >
      {children}
    </ContextoUsuario.Provider>
  );
};

export { ProvedorUsuario, ContextoUsuario };
